<template>
  <CRUDDialog ref="crudDialog" :baseCrudKey="baseCrudKey" :canSave="false" :tabsList="tabsList"
  @crudDialogClose="crudDialogClose" dialogDynamicWidth="650">
  <template v-slot:[`editedItem`]="{}">
    <v-tabs-items v-model="tabsInit">
      <v-tab-item class="ma-3" eager>
        <v-row>
          <v-col cols="2" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-3" label="Tax Year"
            v-model="editedItem.taxYear" readonly tabindex="-1" />
          </v-col>
          <v-col cols="2" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-3"
            @click="onTaxIdClick()" @focus="onTaxIdClick()" label="Tax ID"
            @blur="checkTaxIdIsFree()" @change="checkTaxIdIsFree()"
            :error-messages="taxIdInUseMsg"
            v-model.number="editedItem.taxId" :rules="isTaxOmitExits" />
          </v-col>
          <v-col cols="2" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-3"
            label="Base ID" v-model.number="editedItem.baseId" />
          </v-col>
          <v-col cols="4" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-3" label="Parcel ID" :rules="pIdRules"
            v-model="editedItem.propertyOrParcelId"
            @blur="formatToPidWithDashes('propertyOrParcelId')"
            @focus="formatToPidWith('propertyOrParcelId'), $event.target.select()"
            v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="2" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-3" label="Owner Number"
            v-model="editedItem.ownerId" v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="4" class="ma-0 pb-0 pt-0">
            <CommonDropDowns class="mt-n4" :isItTaxType=true @change="dataFromCommonDropDowns"
             :taxTypeValue="editedItem.taxType" :taxTypeRequired="true" />
          </v-col>
          <v-col cols="4" class="ma-0 pb-0 pt-0">
            <CommonDropDowns class="mt-n4" :isItTaxDistrict=true
           @change="(val, whichField) => { dataFromCommonDropDowns(val, whichField);
               handleCalculatedTax() }"
            :taxDistrictValue="editedItem.schoolDistrict" :isItTaxDistrictRequired="true" />
          </v-col>
          <v-col cols="4" class="ma-0 pb-0 pt-0">
            <v-text-field class="input-text-size pa-0 mt-n1"
            label="Tax/ Assessment Amount" v-model="editedItem.totalTax"
            :value="taxAmtFormatted.totalTax" :rules="rulesForTaxAmt"
            @blur="roundAmount('totalTax'), handleCalculatedTax()"
            @focus="amountToNum('totalTax'), $event.target.select()" />
          </v-col>
          <v-col cols="4" class="ma-0 pb-0 pt-0">
            <CommonDropDowns class="mt-n6" :isItAdditions=true :taxAdditionValue="editedItem.addition"
              @change="dataFromCommonDropDowns"/>
          </v-col>
          <v-col cols="8" class="d-flex justify-space-between ma-0 pb-0 pt-0">
          <label class="input-text-size red--text">Total Levies: </label>
          <label class="input-text-size">{{ totalLevies || 0 }}</label>
          <label class="input-text-size red--text">Calculated Tax Amount:</label>
          <label class="input-text-size">{{ calculatedTaxAmount || 0}}</label>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col cols="12" class="ma-0 pb-0 pt-0">
              <v-textarea class="input-text-size pa-0 mt-2 dec-line-height mb-n9"
               outlined rows="5" label="Legal" v-model="editedItem.legalDesc"
               v-textAreaUppercase=globalSettingItem.conEverythingToCaps />
            </v-col>
            <v-col cols="6" class="ma-0 pb-0 pt-0">
              <CommonDropDowns class="mt-2" :isItTaxAdjTypes=true
              @change="dataFromCommonDropDowns"
              :taxAdjTypesValue="editedItem.adjTypes" :taxAdjTypesRequired="true" />
              <ClarionDateControl class="input-text-size pa-0 mt-n4 mb-1"
               label="Cert Date" :isToggle="false"
               :isRequired="true" v-model="editedItem.certDateValue" />
               <v-row>
                <v-col cols="6" class="ma-0">
                  <v-text-field class="input-text-size pa-0 mt-n1" label="Cert Number"
                    v-model="editedItem.certificateNumber" />
                </v-col>
                <v-col cols="6" class="ma-0">
                  <v-text-field class="input-text-size pa-0 mt-n1" label="Invoice Number"
                    v-model="editedItem.invoiceNumber" />
                </v-col>
              </v-row>
              <ClarionDateControl class="input-text-size mt-n6"
              :isToggle="false" v-model="editedItem.penaltyStartDate"
              label="Penalty Start Date" :rules="rules"
              @blurred="penaltyStartDateOnBlurred" />
            </v-col>
            <v-col cols="6" class="ma-0 pb-0 pt-0">
            <CommonDropDowns class="mt-15" :isItTaxFee=true @change="dataFromCommonDropDowns"
            :taxFeeNumValue="editedItem.feeNumber" :taxFeeRequired="getIsDisabledForFeeNumber()" />
            <v-text-field class="input-text-size pa-0"
            @change="getIsDisabledForFeeNumber()" label="Fee Amount"
              v-model="editedItem.feeAmount" :rules="rulesFeeAmt" @blur="roundAmount('feeAmount')"
              @focus="amountToNum('feeAmount'), $event.target.select()" />
            <CommonDropDowns class="pa-0 mt-n5" :isItstaCode=true
            @change="dataFromCommonDropDowns" :staCodeValue="editedItem.staCode" />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-text-field class="input-text-size pa-0" label="Land"
            v-model.number="editedItem.land" @blur="handleCalculatedTax()" />
          <v-text-field class="input-text-size pa-0 mt-n1" label="Improvements"
            v-model.number="editedItem.improvements" @blur="handleCalculatedTax()"/>
          <v-text-field class="input-text-size pa-0 mt-n1" label="Mobile Home"
            v-model.number="editedItem.mobileHome" @blur="handleCalculatedTax()"/>
          <v-text-field class="input-text-size pa-0 mt-n1" label="Penalty"
            v-model.number="editedItem.assessorPenalty" @blur="handleCalculatedTax()"/>
          <v-text-field class="input-text-size pa-0" label="Exemptions"
            v-model.number="editedItem.exemptions" @blur="handleCalculatedTax()"/>
          <v-text-field class="input-text-size pa-0 mt-n1" label="Net Assessed"
            :value="netAssesedValue" readonly tabindex="-1" />
        </v-col>
        <h4 class="input-text-size red--text text-center"
          v-if="checkIfWarningIsThereOrNot()">WARNING: TAX AMOUNT DOES NOT MATCH CALCULATED AMOUNT
        </h4>
        </v-row>
      </v-tab-item>
      <v-tab-item class="ma-3" eager>
        <v-row>
        <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Name 1" v-model="editedItem.name1" :rules="rulesToCheckEmpty"
          :maxlength="newRecordMaxLength"
          v-uppercase=globalSettingItem.conEverythingToCaps />
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Name 2" v-model="editedItem.name2"
          :maxlength="newRecordMaxLength"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
        label="Address 1" v-model="editedItem.address1" :rules="addressRules"
        :maxlength="newRecordMaxLength"
        v-uppercase=globalSettingItem.conEverythingToCaps />
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Address 2" v-model="editedItem.address2"
          :maxlength="newRecordMaxLength"
          v-uppercase=globalSettingItem.conEverythingToCaps />
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Address 3" v-model="editedItem.address3"
          :maxlength="newRecordMaxLength"
          v-uppercase=globalSettingItem.conEverythingToCaps />
          <v-text-field class="input-text-size pa-0 mt-n1"
          label="Address 4" v-model="editedItem.address4"
          :maxlength="newRecordMaxLength"
          v-uppercase=globalSettingItem.conEverythingToCaps />
          <v-row>
            <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="City" v-model="editedItem.city" :rules="rulesToCheckEmpty"
             :maxlength="newRecordMaxLength"
             v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="State" v-model="editedItem.state" :rules="rulesToCheckEmpty"
             :maxlength="newRecordMaxLength"
             v-uppercase=globalSettingItem.conEverythingToCaps />
          </v-col>
          <v-col cols="4">
            <v-text-field class="input-text-size pa-0 mt-n1"
             label="Zip" v-model="editedItem.zip" :rules="rulesToCheckEmpty"
             :maxlength="newRecordMaxLength"
             @blur="zipFormatter('zip')" :value="formattedValues.zip"
             @focus="zipUnformatter('zip'), $event.target.select()" />
          </v-col>
        </v-row>
        <v-text-field class="input-text-size pa-0 mt-n1" label="Country"
        v-model="editedItem.country" :maxlength="newRecordMaxLength"
        v-uppercase=globalSettingItem.conEverythingToCaps />
      </v-col>
        <v-col cols="6">
          <v-text-field class="input-text-size pa-0 mt-n1"
         label="In Care of 1" v-model="editedItem.inCareOf1"
         :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
         :maxlength="newRecordMaxLength"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="In Care of 2" v-model="editedItem.inCareOf2"
         :readonly="disableInCareOfFields" :tabindex="disableInCareOfFields ? -1 : 0"
         :maxlength="newRecordMaxLength"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Email Address" v-model="editedItem.emailAddess"
         :maxlength="newRecordMaxLength"
         v-uppercase=globalSettingItem.conEverythingToCaps />
        <v-text-field class="input-text-size pa-0 mt-n1"
         label="Primary Phone" v-model="editedItem.primaryPhone" />
        <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="11"
         label="Owner Info Consolidated View" :value="handleConsolidateView()"/>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item class="ma-3">
        <v-row>
        <v-col cols="6" class="pt-0 pb-0">
          <v-text-field class="input-text-size" label="VIN #" v-model="editedItem.mhVin" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0">
          <v-text-field class="input-text-size" label="Year Built"
            v-model.number="editedItem.mhYearBuilt" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Make" v-model="editedItem.mhMake" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
        <v-text-field class="input-text-size" label="Description" v-model="editedItem.mhDescription"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Tag" v-model="editedItem.mhTag" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Title" v-model="editedItem.mhTitle"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Price" v-model.number="editedItem.mhPrice"/>
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Location" v-model="editedItem.mhLocation"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Decal" v-model="editedItem.mhDecal" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <ClarionDateControl class='input-text-size mt-4' v-model='editedItem.mhDecalDate'
          label='Decal Date' :isToggle="false" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Tax ID of Real Estate"
          v-model.number="editedItem.taxIdOfRealEstate" type="Number" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Parcel ID of Real Estate"
          v-model="editedItem.pIdOfRealEstate" @blur="formatToPidWithDashes('pIdOfRealEstate')"
          @focus="formatToPidWith('pIdOfRealEstate'), $event.target.select()"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    </template>
    <template v-slot:[`additionalActionsAfterSave`]="{}">
      <v-btn class="input-text-size" text color="blue darken-1"
      @click="upsertRecordsFromCrud()"
      :disabled="enableSaveBtn() || disableSaveBtn || !!taxIdInUseMsg">Save</v-btn>
    </template>
  </CRUDDialog>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import {
  amountFormat, amountToNumber, pIdFormat, zipDeFormat, zipFormat,
} from '../../../../util/shared/vue-global';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';
import PenaltyStartDateSnap from '../../common-utils/PenaltyStartDateSnap.mixin.vue';
import InCareOfSetting from '../../common-utils/inCareOf.mixin';
import { createOmitTabs } from '../TaxInquiryUtils/TaxInquiry.utils';
import { commonFuncForConsolidateView } from '../../common-utils/tax-common.util';
import '../../../../assets/style.css';

export default {
  mixins: [GlobalToCaps, PenaltyStartDateSnap, InCareOfSetting],
  data() {
    return {
      taxAmtFormatted: {
        totalTax: null,
        land: null,
        improvements: null,
        mobileHome: null,
        assessorPenalty: null,
        exemptions: null,
      },
      tabsList: createOmitTabs,
      formattedValues: {
        zip: '',
      },
      totalLevies: 0,
      grossAssessed: 0,
      netAssessed: 0,
      calculatedTaxAmount: 0,
      taxIdInUseMsg: '',
    };
  },
  mounted() {
    this.roundAmount('totalTax');
    this.roundAmount('feeAmount');
    this.tabsList = createOmitTabs;
    if (this.editedItem.schoolDistrict) this.handleCalculatedTax();
  },
  created() {
    if (this.editedItem.schoolDistrict) this.handleCalculatedTax();
  },
  components: {
    CommonDropDowns,
    ClarionDateControl,
    CRUDDialog,
  },
  computed: {
    ...mapGetters('base/crud', [
      'item', 'selectedTab',
    ]),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rules() {
      return [
        (v) => {
          if (Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    rulesForTaxAmt() {
      return [
        (v) => {
          // if netAssesedValue is not 0, then taxAmt is required
          if (Number(this.netAssesedValue) && Number(v) === 0) {
            return 'Required';
          }
          return true;
        },
      ];
    },
    rulesToCheckEmpty() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    addressRules() {
      return [
        // if any address field is filled no need to validate
        (v) => (!!v || !!this.editedItem.address2 || !!this.editedItem.address3 || !!this.editedItem.address4) || 'Required.',
        () => true,
      ];
    },
    rulesFeeAmt() {
      return [
        (v) => {
          if (Number(this.editedItem.feeNumber)) return !!v || 'Required.';
          return true;
        },
      ];
    },
    isTaxOmitExits() {
      return [
        () => {
          if (!this.taxSettingItem.omittedProperties) {
            return 'Required Omitted Properties from Tax-setting';
          }
          return true;
        },
      ];
    },
    pIdRules() {
      return [
        (v) => {
          if (this.editedItem.taxType && (this.editedItem.taxType).toUpperCase() === 'R') return !!v || 'Required.';
          return true;
        },
      ];
    },
    netAssesedValue() {
      return amountToNumber(this.editedItem.land) + amountToNumber(this.editedItem.improvements)
      + amountToNumber(this.editedItem.mobileHome) + amountToNumber(this.editedItem.assessorPenalty)
      - amountToNumber(this.editedItem.exemptions);
    },
    tabsInit: {
      get() {
        return this.selectedTab(this.baseCrudKey);
      },
      set(value) {
        this.setSelectedTab([this.baseCrudKey, value]);
      },
    },
    isNewRecord() {
      return this.baseCrudKey === 'createNewOmitForm';
    },
    newRecordMaxLength() {
      return this.isNewRecord ? 40 : undefined;
    },
  },
  watch: {
    // The id changing - typed, or replaced by the 1.2s auto-fill poll - makes any
    // standing "already exists" message about the old id, so drop it. The blur/change
    // handler and the save-time check put it back if the new id is taken too.
    'editedItem.taxId': function onTaxIdChanged() {
      this.taxIdInUseMsg = '';
    },
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'createOmit',
    },
    disableSaveBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', [
      'setItem',
      'setIsVisible',
      'setSelectedTab',
    ]),
    ...mapMutations('tax/taxInquires', [
      'setIsTaxIdClicked',
    ]),
    ...mapActions('tax/taxInquires', [
      'calculateTaxes',
      'checkTaxIdExists',
    ]),
    dataFromCommonDropDowns(val, whichField) {
      if (whichField === 'taxDistrict') this.editedItem.schoolDistrict = val;
      else this.editedItem[whichField] = val;
    },
    roundAmount(val) {
      const formatedAmt = amountFormat(amountToNumber(this.editedItem[val]));
      this.editedItem[val] = formatedAmt;
      this.taxAmtFormatted[val] = formatedAmt;
    },
    amountToNum(val) {
      const formatedAmt = amountToNumber(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.taxAmtFormatted[val] = formatedAmt;
    },
    // Nothing stops a county typing a Tax ID that is already on a record for the year,
    // and the pre-filled id is only the highest one seen when the poll last ran, so two
    // workstations can be holding it at the same time. Ask the server.
    async checkTaxIdIsFree() {
      const taxYear = Number(this.editedItem.taxYear);
      const taxId = Number(this.editedItem.taxId);
      if (!taxYear || !taxId) {
        this.taxIdInUseMsg = '';
        return true;
      }
      const res = await this.checkTaxIdExists({ taxYear, taxId });
      // The auto-fill poll may have moved the id while the query was in flight; a
      // verdict about the id we asked about would be wrong against the one on screen.
      if (Number(this.editedItem.taxId) !== taxId
        || Number(this.editedItem.taxYear) !== taxYear) return true;
      // res is null when the check itself failed - don't block the save on that, the
      // upsert resolver refuses duplicates too.
      this.taxIdInUseMsg = res && res.exists ? `Tax ID ${taxId} already exists for ${taxYear}` : '';
      return !this.taxIdInUseMsg;
    },
    async upsertRecordsFromCrud() {
      const validate = this.$refs.crudDialog.validateForm();
      this.checkFormValidOrNot('red');
      if (!validate) return;
      // Re-check on the way out: the id can be claimed by another workstation between
      // the blur check and this click, and an auto-filled id was never blurred at all.
      const taxIdIsFree = await this.checkTaxIdIsFree();
      if (!taxIdIsFree) return;
      const val = this.editedItem;
      this.$emit('upsertCallBack', val);
      this.checkFormValidOrNot();
    },
    getIsDisabledForFeeNumber() {
      if (Number(this.editedItem.feeAmount)) return true;
      return false;
    },
    onTaxIdClick() {
      this.setIsTaxIdClicked(true);
    },
    crudDialogClose() {
      this.tabsList = createOmitTabs;
      this.setIsVisible(['createOmit', false]); // to close omit dialog
    },
    zipUnformatter(val) {
      const formatedAmt = zipDeFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
    },
    zipFormatter(val) {
      const formatedAmt = zipFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
    },
    formatToPidWithDashes(val) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.editedItem[val], formatPidPositions);
      this.editedItem[val] = formattedPid;
    },
    formatToPidWith(val) {
      const formatedPid = (this.editedItem[val] || '').replace(/-/g, '');
      this.editedItem[val] = formatedPid;
    },
    checkFormValidOrNot(whatColor = '') {
      const mappedArr = (createOmitTabs || []).map((ft) => {
        const item = ft;
        if (item.id === 0) item.color = whatColor;
        if (item.id === 1) item.color = whatColor;
        return item;
      });
      this.tabsList = mappedArr;
    },
    checkIfWarningIsThereOrNot() {
      if (amountToNumber(this.calculatedTaxAmount)
       === amountToNumber(this.editedItem.totalTax)) {
        return false;
      } return true;
    },
    enableSaveBtn() {
      // if netAssesedValue is not 0, then check if taxAmt is matching with calculated tax amount
      if (Number(this.netAssesedValue)) {
        if ((amountToNumber(this.calculatedTaxAmount) !== amountToNumber(this.editedItem.totalTax))
        && this.taxSettingItem.restrictAdjSavingOnTaxAmtNtMatching) {
          return true;
        } return false;
      } return false;
    },
    async handleCalculatedTax() {
      const selectedItem = this.editedItem;
      const criteria = {
        land: amountToNumber(selectedItem.land),
        improvements: amountToNumber(selectedItem.improvements),
        mobileHome: amountToNumber(selectedItem.mobileHome),
        exemptions: amountToNumber(selectedItem.exemptions),
        totalTax: amountToNumber(selectedItem.totalTax),
        schoolDistrict: selectedItem.taxDistrict || selectedItem.schoolDistrict,
        taxYear: selectedItem.taxYear,
        penalty: amountToNumber(selectedItem.assessorPenalty),
      };
      const response = await this.calculateTaxes({ criteria });
      this.totalLevies = amountFormat(response.totalLevies);
      this.grossAssessed = amountFormat(response.grossAssessed);
      this.netAssessed = amountFormat(response.netAssessed);
      this.calculatedTaxAmount = amountFormat(response.calculatedTax);
      return response;
    },
    handleConsolidateView() {
      return commonFuncForConsolidateView(this.editedItem);
    },
  },
};
</script>
